import Usuario from "@/model/usuario/Usuario";
import Vue from "vue";
import VueRouter from "vue-router";
import routes from "./routes";
import utilsStorage from "@/utils/storage";
import { TIPO_PERFIL_USUARIO } from "@/constants/geral-constants";

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.name == "Usuarios") {
    let usuario = new Usuario(utilsStorage.obterUsuarioAtualStorage());
    if (usuario.perfil.id != TIPO_PERFIL_USUARIO.ADMIN) {
      next({ name: "Dashboard" });
    }
    next();
  }

  if (to.name == "Grupos") {
    let usuario = new Usuario(utilsStorage.obterUsuarioAtualStorage());
    if (usuario.perfil.id === TIPO_PERFIL_USUARIO.ANALISTA) {
      next({ name: "Dashboard" });
    }
    next();
  }

  if (to.name == "Login") {
    next();
  } else if (to.matched.some((record) => record.meta.requireAuth)) {
    if (localStorage.getItem("token-cp") == null) {
      next({
        path: "/login",
        params: { nextUrl: to.fullPath },
      });
    } else {
      next();
    }
  } else {
    if (localStorage.getItem("token-cp") == null) {
      next();
    } else {
      next({ name: "Dashboard" });
    }
  }
});

export default router;
